<script setup>
import { ref, nextTick } from 'vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import KnowledgeBaseAPI from 'dashboard/api/knowledgeBase';
import { useAlert } from 'dashboard/composables';

const emit = defineEmits(['saved']);

const dialogRef = ref(null);
const url = ref('');
const isLoading = ref(false);

const open = () => {
  url.value = '';
  isLoading.value = false;
  nextTick(() => {
    dialogRef.value?.open();
  });
};

const close = () => {
  dialogRef.value?.close();
};

const crawl = async () => {
  const targetUrl = url.value.trim();
  if (!targetUrl || !targetUrl.startsWith('http')) {
    useAlert('请输入完整的网页网址（必须以 http:// 或 https:// 开头）');
    return;
  }

  isLoading.value = true;
  try {
    const res = await KnowledgeBaseAPI.crawlPage(targetUrl);
    const chunks = res.data?.chunks || 0;
    useAlert(`网页抓取解析成功，已导入 ${chunks} 个知识片段 ✓`);
    emit('saved');
    close();
  } catch (error) {
    useAlert(error.response?.data?.detail || error.response?.data?.error || error.message || '抓取失败');
  } finally {
    isLoading.value = false;
  }
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    title="抓取在线帮助网页"
    confirm-button-label="开始抓取并入库"
    cancel-button-label="取消"
    :is-loading="isLoading"
    :disable-confirm-button="!url.trim()"
    width="lg"
    @confirm="crawl"
  >
    <div class="flex flex-col gap-3 py-2">
      <label class="text-xs font-medium text-n-slate-11">
        页面 URL 网址 <span class="text-n-ruby-11">*</span>
      </label>
      <input
        v-model="url"
        type="url"
        placeholder="https://example.com/help-page"
        class="reset-base !mb-0 w-full px-3 py-2 text-sm border rounded-lg border-n-weak bg-n-alpha-1 text-n-slate-12 placeholder:text-n-slate-10 focus:bg-n-alpha-2 focus:border-n-brand focus:outline-none focus:ring-1 focus:ring-n-brand"
        @keyup.enter="crawl"
      />
      <p class="text-xs text-n-slate-10">
        系统将爬取该页面正文、清洗 HTML 标签，并自动切片转换为知识库文档片段。
      </p>
    </div>
  </Dialog>
</template>
